module.exports = __webpack_public_path__ + "img/greenhouse (1).99a7e7ee.png";